import React from 'react'
import { useQuery } from '@apollo/client'
import Loading from '../Loading'
import Error from '../Error'
import query from '../ReadingTypes/List/Items/lib/query'
import RelationSelectInput from './Relation/Select'

export default (props) => {
  const { loading, error, data } = useQuery(query)

  if (loading) return <Loading />
  if (error) return <Error />

  return (
    <RelationSelectInput
      label='Reading Type'
      name='readingTypeId'
      options={data.readingTypes}
      {...props}
    />
  )
}
